document.addEventListener('DOMContentLoaded', function() {
  const shareButtons = document.querySelectorAll('.button--2');
  const copyBtns = document.querySelectorAll('.copy-btn');

  shareButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      if (e.target.classList.contains('button--2') || e.target.closest('.button--2') && !e.target.closest('.copy-btn')) {
        e.preventDefault();
        e.stopPropagation();
        
        shareButtons.forEach(item => {
          if (item !== this) item.classList.remove('active');
        });
        this.classList.toggle('active');
      }
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.button--2')) {
      shareButtons.forEach(btn => btn.classList.remove('active'));
    }
  });

  copyBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const url = this.dataset.url;
      const self = this;
      
      navigator.clipboard.writeText(url).then(() => {
        self.textContent = '✔ COPIED';
        self.classList.add('success');
        setTimeout(() => {
          self.textContent = 'COPY';
          self.classList.remove('success');
        }, 1500);
      });
    });
  });
});